import React from 'react';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';

const SuccessStories = () => {
  const stories = [
    {
      names: "Sana & Ali",
      story: "We found each other on MarryCenter after both being skeptical about online matrimony. Today, we're happily married with a beautiful baby girl!",
      image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
      duration: "Married 2 years"
    },
    {
      names: "Mehwish & Riaz",
      story: "The compatibility matching really works! We connected instantly and knew we were meant for each other within weeks of talking.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
      duration: "Engaged 6 months"
    },
    {
      names: "Komal & Zain",
      story: "After years of searching, MarryCenter helped me find my perfect match. We share the same values, dreams, and vision for life.",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
      duration: "Married 1 year"
    }
  ];

  return (
    <section id="success" className="py-24 bg-transparent relative overflow-hidden">
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20 animate-fade-in-up">
          <span className="text-pink-400 font-semibold tracking-wider uppercase text-sm mb-2 block">Testimonials</span>
          <h2 className="text-4xl lg:text-5xl font-romantic font-bold text-white mb-6">
            Success <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-rose-400">Stories</span>
          </h2>
          <p className="text-xl text-white max-w-2xl mx-auto">
            Real couples who found their forever through MarryCenter. Join our growing family of happy marriages.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stories.map((story, index) => (
            <div key={index} className="group relative p-8 romantic-glass-card mt-8">
              <div className="absolute -top-8 left-8">
                <div className="relative">
                  <div className="absolute inset-0 bg-pink-500 rounded-full blur-md opacity-40 group-hover:opacity-80 transition-opacity duration-300"></div>
                  <img 
                    src={story.image} 
                    alt={story.names}
                    className="relative w-20 h-20 rounded-full object-cover border-4 border-[#120720] shadow-xl"
                  />
                  <div className="absolute -bottom-2 -right-2 bg-gradient-to-br from-pink-500 to-rose-500 w-8 h-8 rounded-full flex items-center justify-center text-white border-2 border-[#120720] shadow-lg">
                    <FaQuoteLeft className="text-xs" />
                  </div>
                </div>
              </div>

              <div className="pt-10">
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <h3 className="text-xl font-bold text-white group-hover:text-pink-400 transition-colors">{story.names}</h3>
                    <p className="text-pink-400 text-sm font-medium">{story.duration}</p>
                  </div>
                  <div className="flex text-yellow-400 space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className="w-4 h-4" />
                    ))}
                  </div>
                </div>
                
                <p className="text-slate-300 italic leading-relaxed text-sm">
                  "{story.story}"
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuccessStories;